/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/ChooseType/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let newEmailTypeValueData = fromData.useDataValue({ viewPath,
context: 'new_email',
path: 'type',
})
let constantData = 'existing'
let aggregateData = fromAggregate.equals(newEmailTypeValueData, constantData)
let onClick = fromHelpers.useOnClickExisting({
  children,
  viewPath
  
})
let newEmailTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'new_email',
path: 'type',
})
let constantData1 = 'form_submit'
let aggregateData1 = fromAggregate.equals(newEmailTypeValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickNew({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="new_email.type"
 data="'existing'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="Existing relation's email"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="new_email.type"
 data="'form_submit'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 onClick={onClick1}
 text="New email"
/>
</div>
{children}
</React.Fragment>)
}